import { AppRef } from 'common/modules/ReactShared';
import { useCallback, useEffect, useRef, useState } from 'react';

const useHintVisibility = (
  shouldAppear = true,
  hintTimeout = 5000
): [boolean, (timeout?: number) => void] => {
  const { createTimeout, dropTimeout } = AppRef.current.utils.useTimeout();
  const [showHint, setShowHint] = useState(false);
  const hintWasShownRef = useRef(false);
  const timeoutRef = useRef<number | null>(null);
  const hintTimeoutRef = useRef(hintTimeout);

  const updateLastInteractionTime = useCallback(
    (timeout = 5000) => {
      hintTimeoutRef.current = timeout;
      if (showHint) setShowHint(false);
    },
    [showHint]
  );

  useEffect(() => {
    if (timeoutRef.current) dropTimeout(timeoutRef.current);

    if (!shouldAppear || hintWasShownRef.current) return undefined;

    timeoutRef.current = createTimeout(() => {
      setShowHint(true);
    }, hintTimeoutRef.current);

    return () => {
      if (timeoutRef.current) dropTimeout(timeoutRef.current);
    };
  }, [shouldAppear, createTimeout, dropTimeout]);

  useEffect(() => {
    if (showHint) {
      hintWasShownRef.current = true;
    }
  }, [showHint]);

  return [showHint, updateLastInteractionTime];
};

export { useHintVisibility };
